import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Navbar";

const Footer = () => (
  <footer className="border-t border-white/10 bg-background">
    <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
      <div className="col-span-2 md:col-span-1">
        <Logo />
        <p className="mt-4 text-sm text-muted-foreground max-w-xs">Organic TikTok growth powered by AI audience targeting. No passwords. No bots.</p>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-sm mb-4">Product</h4>
        <ul className="space-y-3 text-sm text-muted-foreground">
          <li><Link to="/features" className="hover:text-foreground transition-colors" data-testid="footer-features-link">Features</Link></li>
          <li><a href="/#pricing" className="hover:text-foreground transition-colors">Pricing</a></li>
          <li><a href="/#how" className="hover:text-foreground transition-colors">How it works</a></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-sm mb-4">Company</h4>
        <ul className="space-y-3 text-sm text-muted-foreground">
          <li><a href="/#reviews" className="hover:text-foreground transition-colors">Reviews</a></li>
          <li><Link to="/features" className="hover:text-foreground transition-colors">About</Link></li>
          <li><Link to="/contact" className="hover:text-foreground transition-colors" data-testid="footer-contact-link">Contact</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-sm mb-4">Legal</h4>
        <ul className="space-y-3 text-sm text-muted-foreground">
          <li><Link to="/privacy" className="hover:text-foreground transition-colors" data-testid="footer-privacy-link">Privacy</Link></li>
          <li><Link to="/terms" className="hover:text-foreground transition-colors" data-testid="footer-terms-link">Terms</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} CloutRise. Demo growth data for illustration. Not affiliated with TikTok.
    </div>
  </footer>
);

export default Footer;
